<template>
	<div id="intraoralSaveDialog" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false"
		data-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
			<form class="modal-content dialog-content">
				<div class="modal-body">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" style="z-index: 9">
						<span aria-hidden="true">&times;</span>
					</button>
					<div class="container-fluid">
						<div class="row report-row">
							<div class="col-12">
								<span id="intraoralSaveHint" class="form-text">Are you sure you want to save
									intraoral
									changes?</span>
							</div>
						</div>

						<div class="row report-row">
							<div class="col-12">
								<div class="form-check">
									<input type="checkbox" class="form-check-input" id="updateExportedDataCb"
										v-model="updateExportedData">
									<label class="form-check-label" for="updateExportedDataCb">Update exported
										data</label>
								</div>
							</div>

							<div v-show="updateExportedData" class="col-12">
								<hr class="report-split-line" />
							</div>
						</div>

						<div v-show="updateExportedData" class="row report-row">
							<div class="col-12">
								<div class="form-check">
									<input type="checkbox" class="form-check-input" id="updateFilledTeethCb"
										v-model="updateFilledTeeth">
									<label class="form-check-label" for="updateFilledTeethCb">Update root
										stubs</label>
								</div>
							</div>

						</div>

						<div v-show="updateExportedData" class="row report-row">
							<div class="col-12">
								<div class="form-check">
									<input type="checkbox" class="form-check-input" id="updateMeasurementsCb"
										v-model="updateMeasurements">
									<label class="form-check-label" for="updateMeasurementsCb">Update
										measurements</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer wizard-footer">
					<div class="col-6">
						<button type="button" class="btn btn-primary btn-next" aria-label="YES"
							v-on:click="saveClick()">
							YES
						</button>
					</div>
					<div class="col-6">
						<button type="button" class="btn btn-primary btn-next" aria-label="NO"
							v-on:click="closeClick()">
							NO
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import swal from "sweetalert";
import {
	getModelByName,
	startAddingTooth,
	saveIntraoralData
} from "../IntraoralManager";


export default {
	name: "IntraoralSaveDialog",
	data() {
		return {
			updateExportedData: false,
			updateFilledTeeth: false,
			updateMeasurements: false
		};
	},
	methods: {
		closeClick: async function () {
			$("#intraoralSaveDialog").modal("hide");
		},
		saveClick: async function () {
			let result = saveIntraoralData(this.updateExportedData, false,
				this.updateFilledTeeth, this.updateMeasurements);

			$("#intraoralSaveDialog").modal("hide");
		}
	}
};

</script>

<style scoped>
@import "@/css/wizard.css";

.report-split-line {
	margin-left: -15px;
	margin-top: 15px;
	margin-bottom: 0;
	border-top: 1px solid grey;
}

.report-row {
	margin-left: 5px;
}

.expiration-row {
	margin-left: 15px;
	margin-right: 5px;
}

.modal-sm {
	max-width: 400px;
}

.dialog-content {
	background-color: #ffffff;
}

.close {
	margin-right: -8px;
	margin-top: -10px;
}

.row {
	margin-top: 20px;
}

.btn {
	width: 100%;
	border-radius: 0px;
	height: 40px;
	background-color: #0069d9;
}

#intraoralSaveHint {
	text-align: center;
	/* color: green; */
	/* font-size: smaller; */
	margin-top: -10px;
}

.wizard-footer {
	margin-top: 15px;
}

/* input[type="checkbox"] {
	-webkit-appearance: none;
	-moz-border-radius: 0px;
	-webkit-border-radius: 0px;
	border-radius: 0px;
} */
</style>
